<template>
  <v-card outlined class="pa-2 ma-3" v-intersect="onIntersect">
    <div class="heading-label pa-0 mb-2">Benefício de Meia Entrada</div>
    <v-skeleton-loader
      v-if="loading"
      type="text"
      class="mb-1 mt-3"
    ></v-skeleton-loader>
    <div v-else class="mb-2">
      <span class="text-body-2 mb-1">{{ messages.paragraph }}</span>
      <p v-if="messages.expiresAt" class="text-body-2">
        Expira em {{ messages.expiresAt }}
      </p>
    </div>
    <v-btn
      block
      color="primary"
      to="/account/concession"
      class="mt-1"
      depressed
    >
      {{ messages.button || "Verificar benefício" }}
    </v-btn>
  </v-card>
</template>

<script>
import ACCOUNT from "@/services/account";

export default {
  name: "ConcessionVerificationUserDrawer",
  data() {
    return {
      loading: true,
      innerLoading: false,
      concession: null,
      error: null,
    };
  },
  methods: {
    async getConcession() {
      try {
        this.innerLoading = true;
        this.loading = true;
        this.error = null;
        const data = await ACCOUNT.concession.get();
        this.concession = data.concession;
      } catch (error) {
        this.error =
          error.message || "Erro ao buscar benefícios de meia entrada";
      } finally {
        this.loading = false;
        this.innerLoading = false;
      }
    },
    onIntersect(entries) {
      if (this.innerLoading || this.concession) return;
      if (entries[0].isIntersecting) {
        this.getConcession();
      }
    },
  },
  computed: {
    messages() {
      if (!this.concession)
        return {
          paragraph: "Você não possui benefício de meia entrada",
          button: "Verificar benefício",
        };
      if (
        this.concession.status === "PENDING" ||
        this.concession.status === "MANUAL_REVIEW"
      )
        return {
          paragraph: "Sua solicitação está em análise",
          button: "Verificar solicitação",
        };
      if (this.concession.status === "REJECTED")
        return {
          paragraph: "Sua solicitação foi rejeitada",
          button: "Verificar solicitação",
        };

      if (this.concession.status === "REVOKED")
        return {
          paragraph: "Sua benefício foi cancelado",
          button: "Verificar benefício",
        };

      if (this.concession.status === "APPROVED") {
        if (this.concession.expiresAt && this.concession.expiresAt > new Date())
          return {
            paragraph: "Seu benefício de meia entrada está ativo",
            expiresAt: this.concession.expiresAt,
            button: "Verificar solicitação",
          };

        return {
          paragraph: "Sua solicitação foi aprovada",
          button: "Verificar solicitação",
        };
      }
    },
  },
};
</script>
